module.exports = __webpack_public_path__ + "img/swal_icon_success.8368962.png";